/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PowerBiEmbedConfig } from '../models/PowerBiEmbedConfig';
import type { PowerBiReportSummary } from '../models/PowerBiReportSummary';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PowerBiService {
    /**
     * Lists Power BI reports
     * @returns PowerBiReportSummary Returns list of Power BI reports
     * @throws ApiError
     */
    public static listPowerBiReports(): CancelablePromise<Array<PowerBiReportSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pbiReports',
        });
    }
    /**
     * Returns Power BI report embed configuration
     * @returns PowerBiEmbedConfig Returns Power BI embed config
     * @throws ApiError
     */
    public static getPowerBiReportEmbedConfig({
        reportId,
    }: {
        /**
         * Power BI report configuration id
         */
        reportId: string,
    }): CancelablePromise<PowerBiEmbedConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pbiReports/{reportId}/embedConfig',
            path: {
                'reportId': reportId,
            },
        });
    }
}
